module.exports = __webpack_public_path__ + "img/bg20.11d29465.png";